import React from "react";
import PropTypes from "prop-types";

import SkeletonBlock from "../../components/SkeletonBlock/SkeletonBlock";

// Re-used to set layout for skeleton of SizeView and DesignView
import { _VerticalSeparator as VerticalSeparator } from "../../designComponents/VerticalSeparator/style";
import {
  _DesignViewContainer as DesignViewContainer,
  _LayoutSectionDesignView as LayoutSection,
} from "../DesignView/DesignViewStyle";

// Custom SCs used to set layout for skeleton of SummaryView
import {
  _SummaryViewHeadingContainer as SummaryViewHeadingContainer,
  _SummaryViewArticlesContainer as SummaryViewArticlesContainer,
} from "./style";

const SkeletonView = ({ forView }) => {
  switch (forView) {
    case "SizeView":
    case "DesignView":
      return (
        <DesignViewContainer>
          <LayoutSection style={{ marginRight: "30px" }}>
            {/* Preview */}
            <SkeletonBlock height={300} />
            <SkeletonBlock height={50} />
            <SkeletonBlock height={50} />
          </LayoutSection>

          <VerticalSeparator />

          <LayoutSection style={{ marginLeft: "30px" }}>
            {/* Options */}
            <SkeletonBlock height={150} />
            <SkeletonBlock height={150} />

            {/* Additional options in DesignView */}
            {forView === "DesignView" && (
              <>
                <SkeletonBlock height={150} />
                <SkeletonBlock height={100} />
                <SkeletonBlock height={100} />
                <SkeletonBlock height={100} />
                <SkeletonBlock height={150} />
                <SkeletonBlock height={150} />
              </>
            )}
          </LayoutSection>
        </DesignViewContainer>
      );
    case "SummaryView":
      return (
        <>
          <SummaryViewHeadingContainer>
            {/* Page heading */}
            <SkeletonBlock
              width={450}
              height={65}
              additionalStyle={{ maxWidth: "calc(100vw - 2 * 15px" }}
            />
          </SummaryViewHeadingContainer>

          <SummaryViewArticlesContainer>
            {/* Summary of Uterum properties */}
            <SkeletonBlock width={200} height={40} />
            <SkeletonBlock
              width={600}
              height={40}
              additionalStyle={{ maxWidth: "calc(100vw - 2 * 15px" }}
            />

            {/* Articles */}
            <SkeletonBlock height={600} />

            {/* Rest of page */}
            <SkeletonBlock height={200} />
          </SummaryViewArticlesContainer>
        </>
      );
    default:
      return null;
  }
};

SkeletonView.propTypes = {
  forView: PropTypes.oneOf(["SizeView", "DesignView", "SummaryView"])
    .isRequired,
};

export default SkeletonView;
